// src/config/collections.ts - Configuration multi-tenant avec inventory - VERSION GÉNÉRIQUE

export const COLLECTIONS = {
  users: 'users',
  businesses: 'businesses',           // ✅ MODIFIÉ : instituts → businesses
  serviceCategories: 'serviceCategories', // ✅ NOUVEAU : Catégories de services
  services: 'services',
  packs: 'packs',                    // Packs catalogue (forfaits)
  employees: 'employees',
  clients: 'clients',
  prestations: 'prestations',
  campaigns: 'campaigns',
  promotions: 'promotions',
  transactionFollowUpMessages: 'transactionFollowUpMessages',
  appointments: 'appointments',
  
  // Collections Inventory
  productCategories: 'productCategories',  // Catégories de produits par business
  products: 'products',                    // Produits en stock
  stockMovements: 'stockMovements',        // Mouvements de stock (entrées/sorties)
  externalDispatches: 'externalDispatches',// Bons d'envoi externes (sorties groupées)
  externalDestinations: 'externalDestinations', // Boutiques externes réutilisables
  productSales: 'productSales',            // Ventes de produits

  // Corrections / annulations de ventes (événements métier)
  saleCorrectionEvents: 'saleCorrectionEvents',

  // Collections Fabrication (ordres de fabrication)
  manufacturingOrders: 'manufacturingOrders',

  suppliers: 'suppliers',                  // Fournisseurs
  deliveries: 'deliveries',                // Approvisionnements (réceptions fournisseurs)

  // Lieux / sites (multi-sites : magasin + boutique) - gérés par Super Admin
  sites: 'sites', 

  // Collections comptables
  expenses: 'expenses',                    // Dépenses de fonctionnement
  expenseNotes: 'expenseNotes',            // Notes de frais (workflow validation)

  // Nouvelles collections pour inventaires physiques
  inventorySessions: 'inventorySessions',
  inventoryCounts: 'inventoryCounts', 
  inventoryAdjustments: 'inventoryAdjustments',

  // Collections pour les notifications
  notifications: 'notifications',        // Notifications système (stock, RDV, etc.)
  
  // Collection pour les demandes de RDV depuis landing pages
  appointmentRequests: 'appointmentRequests',  // Demandes de RDV publiques
  pickupRequests: 'pickupRequests',            // Demandes de ramassage (marketplace + lien direct)
  pickupCities: 'pickupCities',                // Catalogue villes / quartiers (admin)
  installationRequests: 'installationRequests', // Demandes d'installation depuis la vitrine (/)
  supportTickets: 'supportTickets',              // Tickets support client ↔ NauvaTek

  // Collections pour la gestion des salaires
  salaryAdjustments: 'salaryAdjustments',      // Ajustements salariaux (avances, absences, primes)
  payrolls: 'payrolls',                        // Fiches de paie mensuelles

  // Indicateur de performance (objectifs mensuels + part variable)
  performanceObjectives: 'performanceObjectives',
  /** Catalogue de critères (notation / scorecard) */
  performanceCriteria: 'performanceCriteria',

  // Collections pour la gestion des profils de rôle
  roleProfiles: 'roleProfiles',                // Profils de rôle personnalisés par business

  // Collections pour la gestion des référents
  referents: 'referents',                      // Référents (médecins)
  references: 'references',                    // Références (ventes liées aux référents)

  // Collections pour le module Activité (rapports d'activité + pipeline/opportunités)
  activityReports: 'activityReports',          // Rapports d'activité journaliers
  pipelines: 'pipelines',                      // Pipelines commerciaux (étapes par business)
  opportunities: 'opportunities',              // Opportunités / deals
  stageHistory: 'stageHistory',                // Historique des changements d'étape

  // Collections pour les plans de paiement (échéances)
  paymentPlans: 'paymentPlans',
  paymentPlanPayments: 'paymentPlanPayments',
  paymentPlanPaymentCorrectionEvents: 'paymentPlanPaymentCorrectionEvents',

  // Contrats clients (Super Admin) - mensualité, engagement annuel, paiements
  businessContracts: 'businessContracts',
  businessContractPayments: 'businessContractPayments',

  // Adoption / usage produit (agrégats journaliers — écrits par Cloud Functions)
  usageDaily: 'usageDaily',

  /** Sous-collection businesses/{id}/loyaltyPassVisitOutbox — file retry sync Pass (écritures CF) */
  loyaltyPassVisitOutbox: 'loyaltyPassVisitOutbox',
};

export type CollectionPath = typeof COLLECTIONS[keyof typeof COLLECTIONS];